const viewerScript = require('./bookingsViewerScript');

// The viewer worker only supports js files in the "require" syntax
module.exports = {
  createControllers: viewerScript.createControllers,
  initAppForPage: viewerScript.initAppForPage,
};
